import Reveal from "@/components/escape21/Reveal";

const QUESTIONS = [
  "qual relógio tu usa?",
  "que suplemento tu toma?",
  "que marca é tua camiseta?",
  "qual o teu tênis?",
];

const DailyQuestions = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-4xl text-center">
      <Reveal>
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          intenção de compra
        </span>
        <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          todo dia me perguntam o que eu <span className="e21-serif text-green-400">uso</span>.
        </h2>
      </Reveal>

      <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
        {QUESTIONS.map((q, i) => (
          <Reveal
            key={q}
            delay={i * 80}
            className="rounded-2xl border border-white/10 bg-white/5 p-5"
          >
            <p className="text-sm font-semibold text-white/80">"{q}"</p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={120} className="mt-12">
        <p className="mx-auto max-w-2xl text-lg text-white/70 sm:text-xl">
          minha audiência não só assiste — ela quer viver o mesmo estilo de vida.
        </p>
        <div className="mx-auto mt-8 max-w-2xl rounded-2xl border border-green-400/30 bg-green-400/5 p-8">
          <h3 className="text-xl font-extrabold tracking-[-0.02em] text-white sm:text-2xl">
            é aqui que a tua marca entra.
          </h3>
          <p className="mt-3 text-base text-white/70">
            cada uma dessas perguntas é uma pessoa pronta pra comprar o que eu
            recomendo. tua marca aparece na hora certa, pra quem já confia em mim.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default DailyQuestions;
